import React from "react";
import { useTranslation } from "../../hooks/useTranslation";

/* Botões de exportação com os ícones de formato aprovados no mockup
   (documento PDF vermelho e planilha Excel verde). Rótulos apenas com o
   formato — o conteúdo de ambos é o relatório completo. */
const PdfIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" role="img" aria-label="PDF">
    <path
      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
      fill="var(--ikaro-bg-surface)" stroke="#E2483D" strokeWidth="1.6" strokeLinejoin="round"
    />
    <path d="M14 2v6h6" fill="none" stroke="#E2483D" strokeWidth="1.6" strokeLinejoin="round" />
    <rect x="2.5" y="13" width="13" height="6.6" rx="1.5" fill="#E2483D" />
    <text
      x="9" y="17.75" textAnchor="middle"
      fontFamily="Arial, Helvetica, sans-serif" fontSize="5" fontWeight="700" fill="#fff"
    >
      PDF
    </text>
  </svg>
);

const XlsxIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" role="img" aria-label="Excel">
    <path
      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
      fill="var(--ikaro-bg-surface)" stroke="#1D7044" strokeWidth="1.6" strokeLinejoin="round"
    />
    <path d="M14 2v6h6" fill="none" stroke="#1D7044" strokeWidth="1.6" strokeLinejoin="round" />
    <rect x="2.5" y="13" width="13" height="6.6" rx="1.5" fill="#1D7044" />
    <path d="M6.7 14.4l4.6 3.8M11.3 14.4l-4.6 3.8" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const ExportButtons = ({ onExport, exporting = null }) => {
  const { t } = useTranslation("consumption");
  return (
    <div className="exports">
      <span className="lbl">{t("export")}</span>
      <button
        type="button"
        className="btn btn-export pdf"
        onClick={() => onExport("pdf")}
        disabled={exporting !== null}
      >
        <PdfIcon />
        {exporting === "pdf" ? t("generating") : t("exportPdf")}
      </button>
      <button
        type="button"
        className="btn btn-export xlsx"
        onClick={() => onExport("xlsx")}
        disabled={exporting !== null}
      >
        <XlsxIcon />
        {exporting === "xlsx" ? t("generating") : t("exportExcel")}
      </button>
    </div>
  );
};

export default ExportButtons;
